module.exports = __webpack_public_path__ + "img/1481153666.b2c45e29.jpg";